export enum NftMintSteps {
    Checkout = 'Checkout',
    Complete = 'Complete',
    Error = 'Error',
    Introduction = 'Introduction',
    Loading = 'Loading',
    LoadingMint = 'LoadingMint',
    NameNft = 'NameNft',
    Processing = 'Processing',
    RenameNft = 'RenameNft',
    YatMintedFeedback = 'YatMintedFeedback',
    YatNotVisualized = 'YatNotVisualized',
}

export type VisualiserName = {
    name: string;
};

export interface VisualiserNameParams {
    data: VisualiserName;
}

export type CurrencyConversion = {
    usd_market_cap?: number;
    usd_24h_vol?: number;
    last_updated_at?: number;
    usd?: number;
    usd_24h_change?: number;
};
export interface ConversionRateResponse {
    ethereum?: CurrencyConversion;
    wei?: CurrencyConversion;
}

export enum VisualizerDataKeys {
    VisualizerData = 'VisualizerData',
    VisualizerFileLocations = 'VisualizerFileLocations',
    VisualizerName = 'VisualizerName',
}
